import React, {Component} from 'react';
import styles from 'css/screens/result.css';

/**
 * CallOut：情報発信
 */
export default class CallOut extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <div className={styles.advice}>
        <h2>御社が強化すべきは<span>情報発信</span>です。</h2>
        <p>
          メディア露出だけを追求していませんか？<br />
          オウンドコンテンツやネイティブ広告、インフルエンサー施策、<br />
          ソーシャルメディアなどで多面的に情報を発信しましょう。<br />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/advice/call-out.js